import { BaseClient } from "../client";

interface ComunicationPayload {
  toEmails: any[];
  title: string;
  message: string;
  names: any[];

};


export const postComunication = async (
  requestBody: ComunicationPayload
) => {
  try {
    const response = await BaseClient.post<{ message: string }>(
      'v2/email/sends',
      requestBody
    );
    return response
  } catch (error: any) {
    console.error('error', error)
  }
};
